<script lang="ts" setup>
import type { Parent } from '~~/server/api/faq/category/[slug]'

export interface PagesFaqCategoryMenuProps {
    data: Parent[]
}

const props = defineProps<PagesFaqCategoryMenuProps>()
</script>
<template>
  <ul>
    <PagesFaqMenuItem
      v-for="(category, index) in props.data"
      :key="`faqcai-${index}`"
      :text="category.title"
      :to="{
        name: 'faq-category',
        params: { id: category.slug },
      }"
    />
  </ul>
</template>
